import React, { useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea';
import { useState } from 'react';
import ResponseMsg2 from '../../general/ResponseMsg2'
import axios from 'axios'
import { GiConfirmed } from "react-icons/gi";
import { FaCheck, FaFileImage, FaFilePdf } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';

const Appointments = ({ setLoading, userData }) => {


    const [form, setForm] = useState({
        purpose: '',
        name: '',
        phone: '',
        no_person: '',
        date: '',
        in_time: '',
        out_time: '',
        file: null,
    })

    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [apt, setApt] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
const [showDelete, setShowDelete] = useState(false);
const [selectedApt, setSelectedApt] = useState([]);
const [showConfirm, setShowConfirm] = useState(false);
 

    const handleChange = (e) => {
  const { name, value, files, type } = e.target;

  if (type === "file") {
    const file = files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 2) {

         setResponse2({ message:"File size is too large! Please upload a file smaller than 2MB.", status: 'error' });
                e.target.value = null;
        return;
      }

   
      setForm({
        ...form,
        [name]: file,
      });
    }
  } else {
  
    setForm({
      ...form,
      [name]: value,
    });
  }
};





    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendData = new FormData();

        for (const key in form) {
            if (form[key] !== null && form[key] !== undefined) {
                sendData.append(key, form[key]);
            }
        }

            sendData.append('added_by', userData.user_id);

        setLoading(true);

        try {

            const res = await axios.post(
                "https://api.kcian.in/add-appointment",
                sendData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            setResponse2({ message: 'Appointment Added Successfully.', status: 'success' });
fetchApts();

            setForm({
                purpose: '',
                name: '',
                phone: '',
                no_person: '',
                date: '',
                in_time: '',
                out_time: '',
                file: null
            });

        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };

const fetchApts = async () => {
    setLoading(true);
    try {
        const res = await axios.get('https://api.kcian.in/fetch-appointment');

        const pendingAppointments = res.data.filter(item => item.status?.toLowerCase() == 'pending');

        setApt(pendingAppointments);
    } catch (error) {
        console.log(error);
    } finally {
        setLoading(false);
    }
};


    useEffect(() => {
        fetchApts();
    }, [])


    const filteredData = apt.filter((r) => {
        const term = searchTerm.toLowerCase();
        return (
            (r.name?.toLowerCase() || '').includes(term) ||
            (r.phone?.toLowerCase() || '').includes(term) ||
            (r.addedby_name?.toLowerCase() || '').includes(term)
        );
    });


const handleShowConfirm = (cls) => {
    setSelectedApt(cls);
    setShowConfirm(true);
}

const handleConfirm = async (id, status) => {
  setLoading(true);

  try {
    const res = await axios.put(
      `https://api.kcian.in/edit-appointment/${id}`,
      { status }
    );

    setShowConfirm(false);
    setResponse2({ message: `Appointment ${status} Successfully.`, status: 'success' });
fetchApts();
  } catch (error) {
    console.log(error);
    // setResponse2({ message: 'Error updating appointment', status: 'error' });
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};


const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return "--";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


const formatTime = (timeStr) => {
  if (!timeStr) return '--';

  const [hour, minute] = timeStr.split(':');
  let hours = parseInt(hour);
  const minutes = minute;
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${ampm}`;
};




const handleShowDelete = (cls) => {
    setSelectedApt(cls);
    setShowDelete(true);
}


              const handleDelete = async (aptId) => {
                setLoading(true);
    try {
      const response = await fetch(`https://api.kcian.in/delete-appointment/${aptId}`, {
        method: 'DELETE',
      });

                setLoading(false);

      if (response.ok) {
setApt((prevData) => prevData.filter((product) => product.id !== aptId));
        setShowDelete(false);
        fetchApts();
        setResponse2({ message: 'Appointment Deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
                        setLoading(false);

      console.error('Error deleting data:', error);
    }
  };



    return (
        <>
    <section className="py-4">
      <div className="px-4">
            <HeadingArea message1="Visits/ Meetings" message2="Appointments" />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

            <div className='row'>
                <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>

                    <div className="profile-card">
                        <p className="profile-heading">Add Visitor</p>

                        <form className='mt-4' onSubmit={handleSubmit} >
                            <div className='profile-input-area mb-4'>
                                <label className='profile-badge'>Purpose*</label>
                                <input type='text' className='profile-input' placeholder='Add Purpose'
                                    name='purpose'
                                    value={form.purpose}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className='profile-input-area mb-4'>
                                <label className='profile-badge'>Name*</label>
                                <input type='text' className='profile-input' placeholder='Add Name'
                                    name='name'
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Phone*</label>
                                    <input type='tel' className='profile-input' placeholder='Add Phone'
                                        name='phone'
                                        value={form.phone}
                                        onChange={handleChange}
                                        maxLength={10}
                                    required
                                    />
                                </div>

                            <div className='profile-input-area mb-4'>
                                <label className='profile-badge'>No Of Person</label>
                                <input type='number' className='profile-input' placeholder='Add No Of Person'
                                    name='no_person'
                                    value={form.no_person}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="profile-input-area mb-4">
                                <label htmlFor="homework" className="profile-badge">
                                    Date*
                                </label>
                                <input
                                    type="date"
                                    id="homework"
                                    className="profile-input"
                                    name='date'
                                    value={form.date}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

<div className='profile-input-area mb-4'>
  <label className='profile-badge'>In Time*</label>
  <input
    type='time'
    className='profile-input'
    name='in_time'
    value={form.in_time}
    onChange={handleChange}
    required
  />
</div>

<div className='profile-input-area mb-4'>
  <label className='profile-badge'>Out Time*</label>
  <input
    type='time'
    className='profile-input'
    name='out_time'
    value={form.out_time}
    onChange={handleChange}
    required
  />
</div>


                            <div className="profile-input-area mb-4">
                                <label htmlFor="homework" className="profile-badge">
                                    File
                                </label>
                                <input type="file" id="myFile" name="file" accept=".pdf, image/*" className='profile-input'  onChange={handleChange} />
                            </div>


                            {/* Buttons */}
                            <div className="text-center">
                                <button type='submit' className="profile-btn mt-2"><FaCheck /> Save</button>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Right side */}

                <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                    <div className='profile-card'>

                        <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                            <span className="profile-heading align-content-center">Visitor List</span>

                            <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                <input
                                    type='text'
                                    name='search'
                                    className='profile-input border-bottom rounded-0'
                                    placeholder='Search...'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className='table-responsive'>
                            <table className='w-100 text-center '>

                                <thead className='account-thead'>
                                    <tr>
                                        <th className='rounded-start-4'>S No</th>
                                        <th>Name</th>
                                        <th>Added By</th>
                                        <th>No Of Person</th>
                                        <th>Phone</th>
                                        <th>Date</th>
                                        <th>Attachment</th>
                                        <th className='rounded-end-4'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((data, id) => (
                                            <tr className='account-tr' key={id}>
                                                <td>{id + 1}</td>
                                                <td>{data.name}</td>
                                                <td>{data.addedby_name} ({data.designation})</td>
                                                <td>{data.no_person}</td>
                                                <td>{data.phone}</td>
                                                <td>{formatDate(data.apt_date)}<br />In Time: {formatTime(data.in_time)}<br />Out Time: {formatTime(data.out_time)}</td>
                                                                                            <td>
                                                {data.file ? (() => {
                                                    // Extract file extension
                                                    const ext = data.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${data.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                                                <td>
{(userData.role == 'SupAdmin' || userData.user_id == data.added_by) 
?
<>
                                                    <GiConfirmed className='account-icon1 me-2' title='staus' onClick={() => handleShowConfirm(data)} />
                                                        <RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(data)} />
                                                            </> : '--' }
                                                </td>
                                            
                                            </tr>
                                        ))
                                    ) :
                                        <tr className='account-tr text-center'>
                                            <td colSpan="8">
                                                No Data found.
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Appointment!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Name</th>
                                        <th>Added By</th>
                                        <th>No Of Person</th>
                                        <th>Phone</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Attachment</th>
    <th className='rounded-end-4'>Purpose</th>
</thead>

<tr className='account-tr'>
                                                <td>{selectedApt.name}</td>
                                                                                                <td>{selectedApt.addedby_name} ({selectedApt.designation})</td>
                                                <td>{selectedApt.no_person}</td>
                                                <td>{selectedApt.phone}</td>
                                                <td>{formatDate(selectedApt.apt_date)}<br />In Time: {formatTime(selectedApt.in_time)}<br />Out Time: {formatTime(selectedApt.out_time)}</td>
                                           <td>{selectedApt.status}</td>
      <td>
                                                {selectedApt.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedApt.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedApt.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                                            <td>{selectedApt.purpose}</td>
                      </tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Appointment will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedApt.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}


{showConfirm && (
    <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Confirm This Appointment!</p>

<div className='table-responsive mb-4'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Name</th>
                                        <th>Added By</th>
                                        <th>No Of Person</th>
                                        <th>Phone</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Attachment</th>
    <th className='rounded-end-4'>Purpose</th>
</thead>

<tr className='account-tr'>
                                                <td>{selectedApt.name}</td>
                                                                                                <td>{selectedApt.addedby_name} ({selectedApt.designation})</td>
                                                <td>{selectedApt.no_person}</td>
                                                <td>{selectedApt.phone}</td>
                                                <td>{formatDate(selectedApt.apt_date)}<br />In Time: {formatTime(selectedApt.in_time)}<br />Out Time: {formatTime(selectedApt.out_time)}</td>
                                           <td>{selectedApt.status}</td>
 <td>
                                                {selectedApt.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedApt.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedApt.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                                            <td>{selectedApt.purpose}</td>
                      </tr>

</table>
</div>


<div className='d-flex justify-content-between'>
                <button className='profile-btn2' onClick={() => setShowConfirm(false)}>Go Back</button>

<div>
            <button className='profile-btn me-2' onClick={() => handleConfirm(selectedApt.id, 'Confirmed')}>Confirm</button>
            <button className='profile-btn' onClick={() => handleConfirm(selectedApt.id, 'Cancelled')}>Cancel</button>
            </div>
</div>

</div>
</section>

    </>
)}


</>
    )
}

export default Appointments